import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner, Accordion } from "react-bootstrap";
import ModalCrud from "./Modal";
import { DoLogout, buildDisplayName, conceptos } from "../Utils";
import Pagination from "../Pagination/Pagination";

export default function PaymentList() {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const displayDateTimeFormat = "DD/MM/YYYY HH:mm";
  const displayDayFormat = "DD/MM/YYYY";
  const displayMonthFormat = "MMM YYYY";
  var moment = require("moment");

  const PAGE_SIZE = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});

  const [isLoading, setLoading] = useState(false);
  const [dojos, setDojos] = useState([]);
  const [payments, setPayments] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [paymentDetail, setPaymentDetail] = useState(null);

  const token = JSON.parse(ls.get("jwt"));
  const usuario = JSON.parse(ls.get("userData"));

  useEffect(() => {
    BuildBase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    GetPayments(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const BuildBase = async () => {
    setLoading(true);

    const dojos = await axios
      .get(
        `${API_URL}/dojos?sort[0]=name%3Aasc&fields[0]=id&fields[1]=name&pagination[pageSize]=1000`,
        headerRequest
      )
      .catch((error) => {
        if (error.response.status === 401) DoLogout();
      });
    setDojos(dojos.data.data);

    GetPayments(1);
  };

  function buildDisplayConceptDetail(c) {
    let text = "";
    //console.log({ c });
    switch (c.__component) {
      case "month-dojo.month-dojo":
        text =
          moment(c.month).format(displayMonthFormat) +
          " en " +
          c.dojo.data?.attributes.name;
        break;
      case "day-dojo.day-dojo":
        text =
          moment(c.day).format(displayDayFormat) +
          " en " +
          c.dojo.data.attributes.name;
        break;
      case "grade.grade":
        if (c.exam == null) text = "Sin exámen";
        //else text = c.exam.;
        break;
    }
    return text;
  }

  function buildDisplayConcept(c) {
    const con = conceptos.filter((x) => x.id == c);
    if (con?.length > 0) return con[0].value;
  }

  const GetPayments = async (page) => {
    setLoading(true);

    const payments = await axios
      .get(
        `${API_URL}/payments?populate[concepto][populate]=*&populate=alumno&sort[0]=createdAt%3Adesc&pagination[page]=${page}&pagination[pageSize]=${PAGE_SIZE}&pagination[withCount]=true`,
        headerRequest
      )
      .then((payments) => {
        setPagination(payments.data.meta.pagination);
        return payments.data.data;
      });

    setPayments(payments);
    setLoading(false);
  };

  const PaymentEdit = (e) => {
    setPaymentDetail(e);
    setShowModal(true);
  };

  const PaymentDelete = (e) => {
    setLoading(true);
    axios.delete(`${API_URL}/payments/${e.id}`, headerRequest).then(() => {
      setLoading(false);
      GetPayments(currentPage);
    });
  };

  const renderData = (
    <>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>Alumno</th>
            <th>Registrado</th>
            <th>Concepto</th>
            <th>Detalle</th>
            <th>
              <Button
                size="sm"
                variant="success"
                onClick={() => PaymentEdit(null)}
              >
                CREAR
              </Button>
            </th>
          </tr>
        </thead>
        <tbody>
          {payments.length < 1 ? (
            <tr>
              <td colSpan="5" align="center">
                No hay pagos.
              </td>
            </tr>
          ) : (
            payments.map((e) => (
              <tr id={e.id} key={e.id}>
                <td align="left">
                  {buildDisplayName(e.attributes.alumno.data.attributes)}
                </td>
                <td align="left">
                  {moment(e.attributes.createdAt).format(displayDateTimeFormat)}
                </td>
                <td align="left">
                  {buildDisplayConcept(e.attributes.concepto[0]?.__component)}
                </td>
                <td align="left">
                  {buildDisplayConceptDetail(e.attributes.concepto[0])}
                </td>

                <td align="center" className="w140">
                  <Button
                    size="sm"
                    className="me-2"
                    onClick={() => PaymentEdit(e)}
                    variant="warning"
                  >
                    Editar
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => PaymentDelete(e)}
                    variant="danger"
                  >
                    Borrar
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={pagination.total}
        pageSize={PAGE_SIZE}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3" fluid="lg">
      <h4>PAGOS</h4>
      {isLoading ? <Spinner animation="border" /> : renderData}

      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      {showModal && (
        <ModalCrud
          show={showModal}
          payment={paymentDetail}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) GetPayments(currentPage);
          }}
        />
      )}
    </Container>
  );
}
